import * as React from 'react';
import  Avatar  from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import TextField from '@mui/material/TextField'; 
import Paper from '@mui/material/Paper';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import Typography from '@mui/material/Typography';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { Link } from 'react-router-dom';
import { toastWarn } from '../helpers/toastify';
import useAuthServices from '../services/useAuthServices';
import { useSelector } from "react-redux";
 

// TODO remove, this demo shouldn't need to reset the theme.

const defaultTheme = createTheme();

const Register = () => {

  const {registerApi} = useAuthServices();
  const {loading} = useSelector(state=>state.login.loading)




  const [inputInfos,setInputInfos] = React.useState({
    username:"",
    email:"",
    password:"",
  })

const handleChange = (e) => {
  setInputInfos({
    ...inputInfos,
    [e.target.name] : e.target.value,
  })
}

  const handleSubmit = (event) => {
    event.preventDefault();
    if(!inputInfos.username.trim() || !inputInfos.password.trim()){
        toastWarn("Username and password cant be empty!")
        return;
    }
    console.log(inputInfos);


    registerApi(inputInfos);

  };

  return (
    <ThemeProvider theme={defaultTheme}>
      <Grid container component="main" sx={{ height: '100vh' }}>
        <CssBaseline />
        <Grid
          item
          xs={false}
          sm={4}
          md={7}
          sx={{
            backgroundImage:
              'https://picsum.photos/seed/picsum/800/600',
            backgroundColor: (t) =>
              t.palette.mode === 'light' ? t.palette.grey[50] : t.palette.grey[900],
            backgroundSize: 'cover',
            backgroundPosition: 'left',
          }}
        />
        <Grid item xs={12} sm={8} md={5} component={Paper} elevation={6} square>
          <Box
            sx={{
              my: 8,
              mx: 4,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
            }}
          >
            <Avatar sx={{ m: 1, bgcolor: 'secondary.main' }}>
              <LockOutlinedIcon />
            </Avatar>
            <Typography component="h1" variant="h5">
              Register
            </Typography>
            <Box component="form" noValidate onSubmit={handleSubmit} sx={{ mt: 1 }}>
              <TextField
                margin="normal"
                required
                fullWidth
                id="username"
                label="Username"
                name="username"
                autoComplete="username"
                autoFocus
                value={inputInfos.username}
                onChange={handleChange}
              />
              <TextField
                margin="normal"
                required
                fullWidth
                id="email"
                label="Email"
                name="email"
                autoComplete="email"
                autoFocus
                value={inputInfos.email}
                onChange={handleChange}
              />
              <TextField
                margin="normal"
                required
                fullWidth
                name="password"
                label="Password"
                type="password"
                id="password"
                autoComplete="current-password"
                value={inputInfos.password}
                onChange={handleChange}
              /> 
              <Button
                type="submit"
                fullWidth
                variant="contained"
                sx={{ mt: 3, mb: 2 }}
                disabled={loading}
              >
                Sign Up
              </Button>
              <Grid container> 
                <Grid item>
                  <Link to="/login" variant="body2">
                    {"Do have an account? Sign In"}
                  </Link>
                </Grid>
              </Grid> 
            </Box>
          </Box>
        </Grid>
      </Grid>
    </ThemeProvider>
  );
} 
export default Register